<template>
  <i-bi-gift-fill />
</template>
